import Axios from 'axios'
import Config from '@/config.js'
import FetcherHelper from '@/utils/fetcherHelper'

class Auth {
  static get apiBaseUrl () {
    return `${Config.apiMgmtBaseUrl}/login`
  }

  static login (login, password) {
    return new Promise((resolve, reject) => {
      Axios.post(Auth.apiBaseUrl, {
        login: login,
        password: password
      }, FetcherHelper.getHeaders()).then(response => {
        if (response.status === 200) return resolve(response.data.token)
        return reject(response)
      }).catch(reject)
    })
  }

  static checkInvitation (hashCode) {
    return new Promise((resolve, reject) => {
      Axios.get(`${Auth.apiBaseUrl}/invitation/${hashCode}/check`, FetcherHelper.getHeaders()).then(response => {
        if (response.status === 200) return resolve(response.data)
        return reject(response)
      }).catch(reject)
    })
  }

  static invitation (userId, hashCode, password) {
    return new Promise((resolve, reject) => {
      Axios.post(`${Auth.apiBaseUrl}/invitation/${hashCode}`,{
        userId,
        password
      }, FetcherHelper.getHeaders()).then(response => {
        if (response.status === 200) return resolve(response.data.token)
        return reject(response)
      }).catch(reject)
    })
  }

  static forgotPassword (login, email) {
    return new Promise((resolve, reject) => {
      Axios.post(`${Auth.apiBaseUrl}/forgot-password`,{
        login,
        email
      }, FetcherHelper.getHeaders()).then(response => {
        if (response.status === 200) return resolve(response.data)
        return reject(response)
      }).catch(reject)
    })
  }
}

export default Auth
